export default __webpack_public_path__ + "static/media/1B.d1916ca9.png";